import { render, staticRenderFns } from "./GenerateSlots.vue?vue&type=template&id=a4fa1c70&scoped=true&"
import script from "./GenerateSlots.vue?vue&type=script&lang=js&"
export * from "./GenerateSlots.vue?vue&type=script&lang=js&"
import style0 from "./GenerateSlots.vue?vue&type=style&index=0&id=a4fa1c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fa1c70",
  null
  
)

export default component.exports